import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import debounce from "lodash.debounce";
import { withTranslation } from "react-i18next";

import breakpoints from "../../../styles/breakpoints";

import { Input } from "../Input";

import searchImg from "../../../assets/images/icons/search.svg";
import { shouldResumeBarBeShown } from "../../../helpers/tools";
import CloseIcon from "../../../assets/images/icons/cancel.svg";
import { colors } from "../../../styles/variables";
import { KEY_ENTER, I18N_NAMESPACES } from "../../../helpers/constants";

const InputContainer = styled.div`
  ${breakpoints.smDown} {
    display: flex;
    flex: 1;
    margin-right: 10px;
    height: 60px;
    border: 1px solid ${colors.black};
    flex-flow: row nowrap;
  }
`;

const StyledInput = styled(Input)`
  width: 300px;
  float: right;
  background: url("${searchImg}") no-repeat right 15px center;
  ${breakpoints.smDown} {
    width: 100%;
    flex: 0.9;
    border: none;
    background: none;
  }
`;

const CrossButtonContainer = styled.div`
  min-width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0.1;
  cursor: pointer;
  ${breakpoints.smUp} {
    display: none;
  }
`;

const CrossButton = styled.img`
  width: 12px;
  height: 12px;
`;

class SearchInput extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    initialValue: PropTypes.string,
    t: PropTypes.func.isRequired,
    searchInputPlaceholder: PropTypes.string,
  };

  static defaultProps = {
    initialValue: null,
    searchInputPlaceholder: null,
  };

  handleChange = debounce((value) => {
    const { onChange } = this.props;
    onChange(value);
  }, 400);

  componentDidMount() {
    const { initialValue, onChange } = this.props;
    if (initialValue) onChange(initialValue);
  }

  componentDidUpdate(prevProps) {
    const { initialValue } = this.props;
    const { initialValue: prevInitialValue } = prevProps || {};

    // We update the value of 'this.inputTitle' on all text change events.
    if (initialValue !== prevInitialValue && this.inputTitle) {
      this.inputTitle.value = initialValue || "";
    }
  }

  handleSubmitOnEnter = (event) => {
    if (event.key !== KEY_ENTER) return;
    const { onChange } = this.props;
    onChange(event.target.value);
  };

  /**
   * Clears the search field, when "X" icon is pressed.
   * */
  clearSearchField = () => {
    const { onChange } = this.props;
    this.inputTitle.value = "";
    onChange("");
  };

  render() {
    const { initialValue, t, searchInputPlaceholder } = this.props;
    const isResumeQuizBarShow = shouldResumeBarBeShown();

    return (
      <InputContainer>
        <StyledInput
          placeholder={searchInputPlaceholder || t("winePages:search")}
          onChange={(event) => this.handleChange(event.target.value)}
          defaultValue={initialValue}
          onKeyPress={this.handleSubmitOnEnter}
          isResumeQuizBarShow={isResumeQuizBarShow}
          ref={(el) => {
            this.inputTitle = el;
          }}
        />
        {!!initialValue && (
          <CrossButtonContainer onClick={() => this.clearSearchField()}>
            <CrossButton src={CloseIcon} />
          </CrossButtonContainer>
        )}
      </InputContainer>
    );
  }
}

export default withTranslation(I18N_NAMESPACES.WINE_PAGES)(SearchInput);
